import React, { useEffect, useState } from 'react';

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { getTemplateList } from '~/services/VideoGenService';

type Props = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
};

function TemplateSelect({ value, onChange, label = 'Select Template', disabled }: Props) {
  const [templates, setTemplates] = useState<Array<{ id: string; title: string }>>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoading(true);
      try {
        const response = await getTemplateList();
        const formattedTemplates = response.result.map((template: string) => ({
          id: template,
          title: template,
        }));
        setTemplates(formattedTemplates);
      } catch (error) {
        console.error('Error fetching templates:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTemplates();
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={handleChange} disabled={disabled || loading}>
        {templates.map((template) => (
          <MenuItem key={template.id} value={template.id}>
            {template.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default TemplateSelect;
